import React from 'react';
import './WhyLoveUs.css';

const WhyLoveUs: React.FC = () => {
  const features = [
    {
      icon: '🎓',
      title: 'Expert Teachers',
      description: 'Our passionate educators bring years of experience in early childhood development',
      color: '#0900ff',
      iconBg: 'linear-gradient(135deg, #ff8c42 0%, #ff42d4 100%)'
    },
    {
      icon: '📚',
      title: 'Quality Education',
      description: 'Comprehensive curriculum designed to nurture curious minds',
      color: '#ffd54f',
      iconBg: 'linear-gradient(135deg, #ffd54f, #ffc107)'
    },
    {
      icon: '🌱',
      title: 'Safe Environment',
      description: 'A secure and nurturing space where children thrive',
      color: '#ff8c42',
      iconBg: 'linear-gradient(135deg, #ff8c42, #ff42d4)'
    },
    {
      icon: '🎨',
      title: 'Creative Learning',
      description: 'Encouraging imagination through art, music, and play',
      color: '#ff42d4',
      iconBg: 'linear-gradient(135deg, #ff42d4, #8178ff)'
    }
  ];

  return (
    <section className="why-love-us">
      <div className="container">
        <h2 className="section-title">Why Love Us</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`feature-card`}>
              <div className="feature-icon" style={{ background: feature.iconBg }}>
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyLoveUs;
